import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Ruta/cambioEstadoRutaSeleccion`, method: 'POST', body: {list}, token: token})
}
